import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41cd5c60"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", { charset: "UTF-8" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "viewport",
  content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "首页", -1))
const _hoisted_4 = { style: {"width":"102%"} }
const _hoisted_5 = {
  class: "main",
  style: {"width":"100%"}
}
const _hoisted_6 = { class: "swiper-head" }
const _hoisted_7 = ["onClick", "src"]
const _hoisted_8 = { class: "center" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "partner-title" }
const _hoisted_11 = { class: "partner-title-content text-right" }
const _hoisted_12 = { class: "info" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small" }, "DEHAA ROSSUN RESEARCH CENTER", -1))
const _hoisted_14 = { class: "center-top-content-right wow bounceInRight bg-yellow animated" }
const _hoisted_15 = { class: "box" }
const _hoisted_16 = { class: "title-box" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "center-btn wow swing bg-purple animated" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "center-btn-img",
  src: "statics/ll/img/btn_right.png"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "center-btn-img2",
  src: "/statics/images/test/btn_rightbai.png"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_22 = { class: "center-bg" }
const _hoisted_23 = { class: "center-bot-content container" }
const _hoisted_24 = { class: "center-bot-content-middle2" }
const _hoisted_25 = { class: "title-box" }
const _hoisted_26 = { class: "wow bounceInLeft bg-green animated" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "center-middle-btn" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "center-middle-btn-img",
  src: "statics/ll/img/btn_rightbai.png"
}, null, -1))
const _hoisted_30 = { class: "center-bot-content-middle3 wow lightSpeedIn bg-purple animated" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"video\" data-v-41cd5c60><div class=\"video-main\" data-v-41cd5c60><img class=\"center-middle-btn-img\" src=\"statics/ll/img/btn_rightbai.png\" data-v-41cd5c60><video width=\"100%\" height=\"100%\" controls=\"controls\" data-v-41cd5c60><source src=\"/statics/images/test/video2.mp4\" data-v-41cd5c60></video></div></div>", 1)
const _hoisted_32 = { class: "pc-qh" }
const _hoisted_33 = { class: "v_out v_out_p" }
const _hoisted_34 = { class: "slider-nav" }
const _hoisted_35 = { class: "cate" }
const _hoisted_36 = { class: "catname" }
const _hoisted_37 = { class: "catname" }
const _hoisted_38 = { class: "caten" }
const _hoisted_39 = { class: "slider-nav-container" }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"slider-nav-buttons\" data-v-41cd5c60><div class=\"slider-nav-item slider-nav-item-next next\" data-v-41cd5c60><img class=\"btn_rightbai1c\" src=\"statics/ll/img/btn_right.png\" data-v-41cd5c60><img class=\"btn_rightbai1\" src=\"statics/ll/img/btn_lefthover.png\" data-v-41cd5c60></div><div class=\"slider-nav-item slider-nav-item-prev prev\" data-v-41cd5c60><img class=\"btn_rightbai2c\" src=\"statics/ll/img/btn_right.png\" data-v-41cd5c60><img class=\"btn_rightbai2\" style=\"transform:rotate(0deg);\" src=\"statics/ll/img/btn_lefthover.png\" data-v-41cd5c60></div></div>", 1)
const _hoisted_41 = { class: "slider-nav-pagination" }
const _hoisted_42 = { class: "slider-nav-page" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider-progress slider-nav-progress" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "slider-progress-inner",
    style: {"width":"53.3333px"}
  })
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prev" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0)" })
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "next" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0)" })
], -1))
const _hoisted_46 = { class: "car_qh" }
const _hoisted_47 = { class: "v_show" }
const _hoisted_48 = { class: "v_cont" }
const _hoisted_49 = ["index"]
const _hoisted_50 = { class: "row carshow" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "slider-selection-card-img img-lazyload-container loaded" }
const _hoisted_53 = ["src", "title"]
const _hoisted_54 = { class: "slider-selection-card-content" }
const _hoisted_55 = { class: "slider-selection-card-title" }
const _hoisted_56 = { class: "slider-selection-card-desc" }
const _hoisted_57 = { class: "slider-selection-card-infos row" }
const _hoisted_58 = {
  class: "col-6 slider-selection-card-infos-item slider-selection-card-duration",
  style: {"text-align":"left"}
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "icon icon-date" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#date" })
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "statics/ll/img/cartime.png",
  style: {"display":"inline-block","vertical-align":"text-top"}
}, null, -1))
const _hoisted_61 = ["textContent"]
const _hoisted_62 = { class: "col-6 slider-selection-card-infos-item slider-selection-card-level" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "statics/ll/img/cardate.png",
  style: {"display":"inline-block","vertical-align":"text-top"}
}, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider-selection-card-infos-item-xt" }, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider-selection-card-button" }, [
  /*#__PURE__*/_createElementVNode("span", null, "查看详情")
], -1))
const _hoisted_66 = /*#__PURE__*/_createStaticVNode("<div class=\"Mobile-qh\" data-v-41cd5c60><div class=\"Mobile-qh-tile\" data-v-41cd5c60><h4 data-v-41cd5c60>科技前沿</h4></div><div class=\"Mobile-qh-item\" data-v-41cd5c60><div class=\"row\" data-v-41cd5c60><div class=\"col-6\" data-v-41cd5c60><div class=\"Mobile-qh-item-img\" data-v-41cd5c60><img src=\"\" data-v-41cd5c60></div><div class=\"Mobile-qh-item-word\" data-v-41cd5c60><h5 data-v-41cd5c60>叶绿素用于制作智能纸尿裤</h5><p data-v-41cd5c60> 对于初为父母的人来说，何时给小孩换尿裤是一项挑战。若经常更换纸尿裤似乎没有太多必要，但如果更换不够及时，可能会引起湿疹 </p><a style=\"color:#61baec;\" href=\"/index.php?m=content&amp;c=index&amp;a=show&amp;catid=26&amp;id=9\" data-v-41cd5c60>查看详情</a></div></div><div class=\"col-6\" data-v-41cd5c60><div class=\"Mobile-qh-item-img\" data-v-41cd5c60><img src=\"\" data-v-41cd5c60></div><div class=\"Mobile-qh-item-word\" data-v-41cd5c60><h5 data-v-41cd5c60>家用科技兴起</h5><p data-v-41cd5c60>家用LED光学玻璃面罩</p><a style=\"color:#61baec;\" href=\"/index.php?m=content&amp;c=index&amp;a=show&amp;catid=27&amp;id=12\" data-v-41cd5c60>查看详情</a></div></div></div><div class=\"row\" data-v-41cd5c60><div class=\"col-6\" data-v-41cd5c60><div class=\"Mobile-qh-item-img\" data-v-41cd5c60><img src=\"\" data-v-41cd5c60></div><div class=\"Mobile-qh-item-word\" data-v-41cd5c60><h5 data-v-41cd5c60>国际认证</h5><p data-v-41cd5c60> Oeko-Tex®标准100、Ecocert认证、国家认证、BDIH——经认证的天然化妆品 </p><a style=\"color:#61baec;\" href=\"/index.php?m=content&amp;c=index&amp;a=show&amp;catid=28&amp;id=15\" data-v-41cd5c60>查看详情</a></div></div><div class=\"col-6\" data-v-41cd5c60><div class=\"Mobile-qh-item-img\" data-v-41cd5c60><img src=\"\" data-v-41cd5c60></div><div class=\"Mobile-qh-item-word\" data-v-41cd5c60><h5 data-v-41cd5c60>2018年欧洲非织造布的总产量增长</h5><p data-v-41cd5c60> 根据欧洲非织造布协会（EDANA）最新收集整理的数据，2018年欧洲非织造布总产量达到276万吨 ， 增长1.3%。在过去的十年里，年平均增长率接近4%。 </p><a style=\"color:#61baec;\" href=\"/index.php?m=content&amp;c=index&amp;a=show&amp;catid=26&amp;id=10\" data-v-41cd5c60>查看详情</a></div></div></div></div><div class=\"Mobile-qh-item\" data-v-41cd5c60></div></div>", 1)
const _hoisted_67 = { class: "partner" }
const _hoisted_68 = { class: "container" }
const _hoisted_69 = /*#__PURE__*/_createStaticVNode("<div class=\"partner-title\" data-v-41cd5c60><div class=\"partner-title-content text-right\" data-v-41cd5c60><p class=\"info\" data-v-41cd5c60>国际</p><p class=\"bd-bottom\" data-v-41cd5c60>合作</p><div class=\"small\" data-v-41cd5c60>INTERNATIONAL COOPERATION</div></div></div>", 1)
const _hoisted_70 = { class: "banner" }
const _hoisted_71 = { class: "swiper-container swiper-container-horizontal" }
const _hoisted_72 = {
  class: "swiper-wrapper",
  style: {"transform":"translate3d(0px, 0px, 0px)"}
}
const _hoisted_73 = {
  class: "swiper-slide swiper-slide-active",
  style: {"margin-right":"30px"}
}
const _hoisted_74 = { class: "banner-content" }
const _hoisted_75 = ["href"]
const _hoisted_76 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("html", null, [
    _createElementVNode("head", null, [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        src: "statics/ll/js/swiper.min.js",
        type: "text/javascript",
        charset: "utf-8"
      }))
    ]),
    _createElementVNode("body", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_swiper, {
            modules: _ctx.modules,
            "slides-per-view": 1,
            "space-between": 50,
            navigation: "",
            pagination: { clickable: true },
            scrollbar: { draggable: true },
            autoplay: {
              delay: 1500,
              disableOnInteraction: false,
            },
            onSwiper: _ctx.onSwiper,
            onSlideChange: _ctx.onSlideChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banner, (item, index) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      onClick: ($event: any) => (_ctx.goLink(5,item.content)),
                      src: 
                  _ctx.url +
                  '/' +
                  item.pictureAttachment.filePath +
                  '/' +
                  item.pictureAttachment.id +
                  item.pictureAttachment.suffix
                
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modules", "onSwiper", "onSlideChange"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.show?"研究":"RESEARCH"), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.show?"中心":"CENTER"), 1),
                _hoisted_13
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AboutUS, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "center-top-content",
                key: index
              }, [
                _createElementVNode("div", {
                  class: "center-top-content-left wow bounceInLeft bg-green animated",
                  style: _normalizeStyle(
                  'background-image: url(' +
                  _ctx.url +
                  '/' +
                  item.pictureAttachment.filePath +
                  '/' +
                  item.pictureAttachment.id +
                  item.pictureAttachment.suffix +
                  ')'
                )
                }, null, 4),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.show?"关于我们":"ABOUT US"), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.show?"about us":""), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", {
                        innerHTML: item.content
                      }, null, 8, _hoisted_17)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("a", {
                        class: "center-btn-a",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goLink(1))),
                        style: {"color":"inherit"}
                      }, _toDisplayString(_ctx.show?"查看详情":"DISCOVER"), 1),
                      _hoisted_19,
                      _hoisted_20
                    ])
                  ])
                ]),
                _hoisted_21
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.research, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "center-bot-content-middle",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("h4", _hoisted_26, _toDisplayString(_ctx.show?" 研究与创新":"RESEARCH AND INNOVATION"), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.show?"RESEARCH AND INNOVATION":""), 1)
                    ]),
                    _createElementVNode("span", {
                      innerHTML: item.content
                    }, null, 8, _hoisted_27),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("a", {
                        class: "center-middle-btn-a",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goLink(2)))
                      }, _toDisplayString(_ctx.show?"查看详情":"DISCOVER"), 1),
                      _hoisted_29
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", {
                      class: "img",
                      style: _normalizeStyle(
                      'background-image: url(' +
                      _ctx.url +
                      '/' +
                      item.pictureAttachment.filePath +
                      '/' +
                      item.pictureAttachment.id +
                      item.pictureAttachment.suffix +
                      ')'
                    )
                    }, null, 4)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.show?"科技前沿":"LATEST"), 1),
                _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.show?"":" RESEARCH"), 1),
                _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.show?"LATEST RESEARCH":""), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.num), 1)
                ]),
                _hoisted_43
              ])
            ]),
            _hoisted_44,
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scienceDataArray, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        id: "b",
                        key: index,
                        index: index,
                        style: {"position":"relative"}
                      }, [
                        _createElementVNode("div", _hoisted_50, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.article, (item1, index1) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index1,
                              class: "col-md-3 col-xs-6"
                            }, [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.goLink(3,item1.id, item.name, item1.title)),
                                "data-wow-duration": "1s",
                                class: "wow bounceInRight bg-blue slider-selection-card change-page animated",
                                style: {"visibility":"visible","animation-duration":"1s","animation-name":"bounceInRight"}
                              }, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("img", {
                                    class: "img-lazyload",
                                    "data-lazyload": "true",
                                    src: 
                                 _ctx.url+'/' +
                                  item1.pictureObj.filePath +
                                  '/' +
                                  item1.pictureObj.id +
                                  item1.pictureObj.suffix
                                ,
                                    title: item1.title,
                                    "data-src": "lazyloaded"
                                  }, null, 8, _hoisted_53)
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("h4", _hoisted_55, _toDisplayString(item1.title), 1),
                                  _createElementVNode("p", _hoisted_56, _toDisplayString(item1.summary), 1),
                                  _createElementVNode("div", _hoisted_57, [
                                    _createElementVNode("div", _hoisted_58, [
                                      _hoisted_59,
                                      _hoisted_60,
                                      _createElementVNode("strong", {
                                        textContent: _toDisplayString(
                                      _ctx.moment(item1.createTime).format('YYYY')
                                    )
                                      }, null, 8, _hoisted_61)
                                    ]),
                                    _createElementVNode("div", _hoisted_62, [
                                      _hoisted_63,
                                      _createTextVNode(" " + _toDisplayString(_ctx.moment(item1.createTime).format("MM-DD")), 1)
                                    ]),
                                    _hoisted_64
                                  ])
                                ]),
                                _hoisted_65
                              ], 8, _hoisted_51)
                            ]))
                          }), 128))
                        ])
                      ], 8, _hoisted_49))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_66,
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.internationalCooperationData, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "banner-content-img",
                          key: index
                        }, [
                          _createElementVNode("a", {
                            href: item.sourceUrl
                          }, [
                            _createElementVNode("img", {
                              class: "banner-content-img-ho",
                              src: 
                              _ctx.url +
                              '/' +
                              item.pictureAttachment.filePath +
                              '/' +
                              item.pictureAttachment.id +
                              item.pictureAttachment.suffix
                            
                            }, null, 8, _hoisted_76)
                          ], 8, _hoisted_75)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { src: "statics/js/swiper-bundle.min.js" })),
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        src: "statics/ll/js/popper.min.js",
        type: "text/javascript",
        charset: "utf-8"
      })),
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        src: "statics/ll/js/bootstrap.min.js",
        type: "text/javascript",
        charset: "utf-8"
      })),
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        src: "statics/ll/js/wow.js",
        type: "text/javascript",
        charset: "utf-8"
      }))
    ])
  ]))
}